export enum EmbeddingBehavior {
    CLICK = "click",
    INSTANTLY = "instantly",
    ON_VISIBLE = 'on-visible',
    ON_PREPARED_VISIBLE = 'on-prepared-visible',
}
